(function($) {
    "use strict";

	jQuery(document).ready(function(){
		
	
	
/*=========== Wow Active ===========*/

  new WOW().init();


/*=========== Counter Up===========*/

  $('.count').counterUp({
    delay: 10,
    time: 1000
  });


/*============= Youtub Popup ==============*/

  $('a.video-play-button').yu2fvl();



/*============= Youtub Popup 02 ==============*/

	$('a.video-play-button--2').yu2fvl();



/*=============  Blog Activation  ==============*/


  $(".blog__activation").owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      autoplay: false,
      autoplayTimeout: 10000,
      items:1,
      navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
      dots: false,
      lazyLoad: true,
      responsive:{
        0:{
          items:1
        },
        1920:{
          items:1
        }
      }
    });


/*=============  About Video Activation  ==============*/


  $(".about__video__activation").owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      autoplay: false,
      autoplayTimeout: 10000,
      items:1,
      navText: [ '<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>' ],
      dots: false,
      lazyLoad: true,
      responsive:{
        0:{
          items:1
        },
        1920:{
          items:1
        }
      }
    });

/*=============  Portfolio Activation  ==============*/

  $('.portfolio__area').imagesLoaded( function() {

    // filter items on button click
    $('.portfolio__menu').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });
    });
    
    // change is-checked class on buttons
    $('.portfolio__menu button').on('click', function () {
        $('.portfolio__menu button').removeClass('is-checked');
        $(this).addClass('is-checked');
        var selector = $(this).attr('data-filter');
        $grid.isotope({ filter: selector });
        return false;
  });

    // init Isotope
    var $grid = $('.portfolio__wrap').isotope({
      itemSelector: '.pro__item',
      percentPosition: true,
      transitionDuration: '0.7s',
      layoutMode: 'fitRows',
      masonry: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: 1,
      }
    })

  });



/*=============  Blog Mesonry Activation  ==============*/

  $('.blog__masonry__container').imagesLoaded( function() {

    // filter items on button click
    $('.blog__masonry__menu').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });
    });
    
    // change is-checked class on buttons
    $('.blog__masonry__menu button').on('click', function () {
        $('.blog__masonry__menu button').removeClass('is-checked');
        $(this).addClass('is-checked');
        var selector = $(this).attr('data-filter');
        $containerpage.isotope({ filter: selector });
        return false;
  });

    // init Isotope
    var $grid = $('.blog__masonery__wrap').isotope({
      itemSelector: '.bl__item',
      percentPosition: true,
      transitionDuration: '0.7s',
      masonry: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: 1,
      }
    })


  });


/*=============  Plus Minus Button ==============*/


    $(".cart-plus-minus").append('<div class="dec qtybutton">-</i></div><div class="inc qtybutton">+</div>');

    $(".qtybutton").on("click", function () {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }
        $button.parent().find("input").val(newVal);
    });







/*============= Login Register Form ==============*/

    function loginRegisterForm(){
        var trigger = $('.accountbox-trigger'),
            container = $('.accountbox-wrapper');
            $('<div class="body-overlay"></div>').prependTo(container);

        trigger.on('click', function(e){
            e.preventDefault();
            container.addClass('is-visible');
        });

        $('.body-overlay').on('click', function(){
            container.removeClass('is-visible');
        });

        $('span.accountbox-close-button').on('click', function(){
            container.removeClass('is-visible');
        });

  };
  loginRegisterForm();




/*============= Cartbox Toggler ==============*/

    function cartboxToggler(){
        var trigger = $('.minicart-trigger'),
            container = $('.cartbox-wrap');
        $('<div class="body-overlay"></div>').prependTo(container);

        trigger.on('click', function(e){
            e.preventDefault();
            container.toggleClass('is-visible');
        })
        $('.cartbox-close').on('click', function(){
            container.removeClass('is-visible');
        })
        container.find('.body-overlay').on('click', function(){
            container.removeClass('is-visible');
        })
    };
    cartboxToggler();




/*=========== ScrollUp ===========*/

  $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'slideInRight'
  });


/*=========== Mobile Menu ===========*/

  $('nav.main__menu__nav').meanmenu({
    meanMenuClose: 'X',
    meanMenuCloseSize: '18px',
    meanScreenWidth: '991',
    meanExpandableChildren: true,
    meanMenuContainer: '.mobile-menu',
    onePage: true
  });



/*=========== ScrollReveal Js Init ===========*/

  window.sr = ScrollReveal({ duration: 700 , reset: false});
  sr.reveal('.foo');
  sr.reveal('.bar');



/*=========== Sticky Header ===========*/
function stickyHeader(){
    $(window).on('scroll', function(){
        var sticky_menu = $('.sticky__header');
        var pos = sticky_menu.position();
        if (sticky_menu.length) {
            var windowpos = sticky_menu.top;
            $(window).on('scroll', function() {
               var windowpos = $(window).scrollTop();
               if (windowpos > pos.top + 250) {
                   sticky_menu.addClass('is-sticky');
               } else {
                   sticky_menu.removeClass('is-sticky');
               }
            });
        }
    });
}
stickyHeader();





/*============= Checkout Login/Register Toggle ==============*/
    function checkoutLoginToggle(){
        var checkoutMethodList = $('.checkout-method-list li');
        checkoutMethodList.on('click', function(){
            var form = $(this).data('form');
            if( !$(this).hasClass('active') ) {
                $('.checkout-method-list li').removeClass('active');
                $(this).addClass('active');
                $('.checkout-method form').slideUp(500);
                $('.' + form).delay(500).slideDown();
            }
        });
    }
    checkoutLoginToggle();
    




/*============= Checkout Shipping Form Toggle ==============*/
    function checkoutShippingToggle(){
        var shipingFormToggle = $('.shipping-form-toggle');
        var shipingForm = $('.shipping-form');
        shipingFormToggle.on('click', function(){
            if( $(this).hasClass('active') ) {
                $(this).removeClass('active');
                shipingForm.slideUp();
            } else {
                $(this).addClass('active');
                shipingForm.slideDown();
            }
        });
    }
    checkoutShippingToggle();
    




/*============= Payment Method Toggle ==============*/
    function paymentMethodToggle(){
        var paymentMethodList = $('.payment-method-list li');
        var paymentFormToggle = $('.payment-form-toggle');
        var paymentForm = $('.payment-form');
        paymentMethodList.on('click', function(){
            paymentMethodList.removeClass('active');
            $(this).addClass('active');
            if( $(this).hasClass('payment-form-toggle') ) {
                paymentForm.slideDown()
            } else {
                paymentForm.slideUp()
            }
        });
    }
    paymentMethodToggle();

	
                /* Ajax Cart */
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },700);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1500);

    });  
    
		
		
		

	/* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 
      
      
    /* Match Heigh */  
    $(function() {
		$('.item').matchHeight();
	});  
      
    });

})(jQuery);



